export const FOOD_FIGHT_DURATION = 60000 // 60s
export const ANIMATION_TRIGGER_DELAY = 58500 // 88s
export const AVATAR_DELAY = 0.8 // 800ms
export const BUTTON_DELAY = 62000 // 62s
export const WAVE_HAND_PERIOD = 5000 // 5s
export const MOOD = {
    FUN: 'fun',
    NORMAL: 'normal',
}
